import * as ViewModel from '@/core/presenter/viewModel';
import { PopupType, PopupResultType, PopupIconType } from "@/components/dialog/types";
import { getStores } from "@/stores";
import AlertDialog from "@/components/dialog/components/AlertDialog";
import React from 'react';
import AgreementPopup from "@/components/dialog/components/popups/AgreementPopup";
import PrivacyAgreementPopup from "@/components/dialog/components/popups/PrivacyAgreementPopup";
import TokenTransactionPopup from "@/components/dialog/components/popups/TokenTransactionPopup";
import TrxTransactionPopup from '@/components/dialog/components/popups/TrxTransactionPopup';


/**
 * 확인 팝업
 * @param msg 
 * @param errorMsg 
 * @returns 
   */
export async function showConfirmPopup(msg: string, isIcon?: boolean, errorMsg?: string): Promise<boolean> {
    const ret = await showAlert({
      msg,
      errorMsg,
      okCaption: true,
      cancelCaption: false,
      popupType: PopupType.CONFIRM,
      iconType: PopupIconType.CHECK,
      isIcon,
    });
    return ret === PopupResultType.OK;
  }

export async function showAlertPopup(msg: string, isIcon?: boolean, isAlert?: boolean, errorMsg?: string ): Promise<boolean> {
  const ret = await showAlert({
    msg,
    errorMsg,
    okCaption: true,
    cancelCaption: true,
    popupType: PopupType.ALERT,
    iconType: PopupIconType.EXCLAMATION,
    isIcon,
    isAlert,
  });
  return ret === PopupResultType.OK;
}

  /**
   * 확인 팝업
   * @param opt 
   * @returns 
   */
  export function showAlert(opt: {
    msg: string;
    okCaption?: boolean;
    cancelCaption?: boolean;
    errorMsg?: string;
    popupType: PopupType;
    iconType?: PopupIconType;
    isIcon?: boolean;
    isAlert?: boolean;
  }): Promise<PopupResultType> {
    return new Promise((resolve) => {
      const { dialogStore } = getStores();
      let dialogSeq = 0;
  
      const onCancel = (): void => {
        resolve(PopupResultType.CANCEL);
        dialogStore.hidePopup(dialogSeq);
      };
  
      const onOk = (): void => {
        resolve(PopupResultType.OK);
        dialogStore.hidePopup(dialogSeq);
      };
  
      dialogSeq = dialogStore.pushPopup(
        React.createElement(AlertDialog, {
          msg: opt.msg,
          errorMsg: opt.errorMsg,
          okCaption: opt.okCaption,
          cancelCaption: opt.cancelCaption,
          popupType: opt.popupType,
          iconType: opt.iconType,
          isIcon: opt.isIcon,
          isAlert: opt.isAlert,
          onClose: onCancel,
          onOk: onOk,
        })
      );
    });
  }
  

/**
 * 이용약관 동의 팝업
 * @param popupId 
 * @returns 
 */
export function showAgreementPopup(): Promise<void> {
  return new Promise((resolve) => {
    const { dialogStore } = getStores();
    let dialogSeq = 0;

    const handleCancel = (): void => {
      resolve();
      dialogStore.hidePopup(dialogSeq);
    };

    dialogSeq = dialogStore.pushPopup(
      React.createElement(AgreementPopup, {
        onCancel: handleCancel
      })
    );
  });
}


/**
 * 개인정보 수집 및 이용 동의 팝업
 * @returns 
 */
export function showPrivacyAgreementPopup(): Promise<void> {
  return new Promise((resolve) => {
    const { dialogStore } = getStores();
    let dialogSeq = 0;

    const handleCancel = (): void => {
      resolve();
      dialogStore.hidePopup(dialogSeq);
    };

    dialogSeq = dialogStore.pushPopup(
      React.createElement(PrivacyAgreementPopup, {
        onCancel: handleCancel
      })
    );
  });
}


/**
 * 토큰 거래 팝업
 * @param tokenTransaction 
 * @returns 
 */
export function showTokenTransactionPopup(tokenTransaction: ViewModel.IResponseActivity): Promise<void> {
  return new Promise((resolve) => {
    const { dialogStore } = getStores();
    let dialogSeq = 0;

    const handleCancel = (): void => {
      resolve();
      dialogStore.hidePopup(dialogSeq);
    };

    dialogSeq = dialogStore.pushPopup(
      React.createElement(TokenTransactionPopup, {
        tokenTransaction,
        onCancel: handleCancel,
      })
    );
  });
}

/**
 * 트랜잭션 팝업
 * @param trxTransaction 
 * @returns 
 */
export function showTrxTransactionPopup(trxTransaction: ViewModel.IResponseActivity): Promise<void> {
  return new Promise((resolve) => {
    const { dialogStore } = getStores();
    let dialogSeq = 0;

    const handleCancel = (): void => {
      resolve();
      dialogStore.hidePopup(dialogSeq);
    };

    dialogSeq = dialogStore.pushPopup(
      React.createElement(TrxTransactionPopup, {
        trxTransaction,
        onCancel: handleCancel,
      })
    );
  });
}


